import { motion } from "framer-motion";
import { ArrowRight, Phone, FileCheck2, Upload } from "lucide-react";
import { TID } from "@/constants/testIds";

export default function FinalCTA({ onContact }) {
  return (
    <section className="bg-[#0A2540] text-white relative overflow-hidden">
      <div className="absolute inset-0 hero-grid opacity-[0.07]" />
      <div className="absolute top-10 right-10 h-72 w-72 rounded-full bg-[#10B981]/10 blur-3xl" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28 relative">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <div className="inline-flex items-center gap-2 text-[10px] font-bold tracking-[0.25em] uppercase text-[#10B981] mb-5">
            <span className="h-px w-8 bg-[#10B981]" /> Next Step
          </div>
          <h2 className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            Ready to transform your business?
          </h2>
          <p className="mt-6 text-lg text-white/70 leading-relaxed max-w-2xl">
            Discover opportunities to improve efficiency, eliminate waste, optimize processes, and increase profitability.
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            <button
              data-testid={TID.finalCta.book}
              onClick={onContact}
              className="btn-sharp inline-flex items-center gap-2 px-6 py-3.5 bg-[#10B981] text-white text-sm font-semibold hover:bg-[#0E9F70] hover:-translate-y-0.5 transition-all"
            >
              Book a Consultation <ArrowRight size={16} />
            </button>
            <button
              data-testid={TID.finalCta.assessment}
              onClick={onContact}
              className="btn-sharp inline-flex items-center gap-2 px-6 py-3.5 border border-white/30 text-white text-sm font-semibold hover:bg-white/10 hover:-translate-y-0.5 transition-all"
            >
              <FileCheck2 size={16} /> Request a Business Assessment
            </button>
            <button
              data-testid={TID.finalCta.upload}
              onClick={onContact}
              className="btn-sharp inline-flex items-center gap-2 px-6 py-3.5 border border-white/30 text-white text-sm font-semibold hover:bg-white/10 hover:-translate-y-0.5 transition-all"
            >
              <Upload size={16} /> Upload a Contract for Review
            </button>
            <a
              data-testid={TID.finalCta.call}
              href="tel:9429951975"
              className="btn-sharp inline-flex items-center gap-2 px-6 py-3.5 bg-white text-[#0A2540] text-sm font-semibold hover:bg-slate-100 hover:-translate-y-0.5 transition-all"
            >
              <Phone size={16} /> Call Now: 942-995-1975
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
